import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import PipelinesDeploymentsModal, {
  ModalType,
} from 'src/components/pipelines/components/deployments-modal';
import {
  removeDeploymentData,
  requestDeploymentChanges,
  requestDeploymentSummary,
} from 'src/components/pipelines/redux/actions/deployments';
import { getDeploymentSummary } from 'src/components/pipelines/redux/selectors/deployments';
import { getRepository } from 'src/components/pipelines/redux/selectors/pipelines';
import { publishScreenEvent } from 'src/utils/analytics/publish';

import Changes from './changes';

type Props = {
  onCloseModal: () => void;
  deploymentUuid: string;
};

const SummaryModal = ({ onCloseModal, deploymentUuid }: Props) => {
  const dispatch = useDispatch();
  const {
    deployment,
    lastSuccessfulDeployment,
    revisionFrom,
    revisionTo,
    isRollback,
    createdOn,
  } = useSelector(getDeploymentSummary);
  const { uuid: repositoryUuid } = useSelector(getRepository);

  useEffect(() => {
    publishScreenEvent('deploymentPreviewModal', { repositoryUuid });
    dispatch(requestDeploymentSummary(deploymentUuid));
    return () => {
      dispatch(removeDeploymentData());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (deployment.uuid) {
      dispatch(
        requestDeploymentChanges(
          revisionFrom,
          revisionTo,
          createdOn,
          isRollback
        )
      );
    }
  }, [
    dispatch,
    revisionFrom,
    revisionTo,
    createdOn,
    isRollback,
    deployment.uuid,
  ]);

  return (
    <PipelinesDeploymentsModal
      onCloseModal={onCloseModal}
      modalType={ModalType.SUMMARY}
      deployment={deployment}
      lastSuccessfulDeployment={lastSuccessfulDeployment}
    >
      <Changes
        revisionFrom={revisionFrom}
        revisionTo={revisionTo}
        isRollback={isRollback}
      />
    </PipelinesDeploymentsModal>
  );
};

export default React.memo(SummaryModal);
